import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/accessible-icon': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M423.9 255.8L411 413.1C407.7 453.8 347.1 448.2 350.4 408.2L360.4 285.7 319.3 288C329.4 308.7 335.1 331.9 335.1 356.5 335.1 397.7 319 435.2 292.8 463L253.5 423.7C311.4 360 266.6 256.5 179.5 256.5 153.6 256.5 130 266.4 112.3 282.5L73 243.2C95 222.5 123.1 208.1 154.4 203L229.7 117.3 187.1 92.5 135.5 138.5C105.5 165.3 64.9 120 95 93.1L163 32.4C172.8 23.6 187.1 22.2 198.5 28.8 198.5 28.8 337.8 109.7 338 109.9 354.2 120 358.7 145.9 344.1 162.5L285.7 229 391.8 223.1C410.3 222 425.4 237.5 423.9 255.8zM359 101.8C387.1 101.8 409.9 79 409.9 50.9 409.9 22.8 387.1 0 359 0 330.9 0 308.1 22.8 308.1 50.9 308.1 79 330.9 101.8 359 101.8zM179.6 456.5C99 456.5 52.2 365.9 96.9 300.4L57.2 260.7C36.4 287 24 320.3 24 356.4 24 487.1 174.7 557.8 275.4 478.9L235.7 439.2C219.7 450.1 200.4 456.5 179.6 456.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/accessible-icon.js
// module id = ry7N
// module chunks = 144